import { Component, OnInit } from '@angular/core';
import { BaseComponent } from "app/components/base.component";
import { ImageService, Image } from "app/services/image.service";
import { Router } from '@angular/router';
import { PaginationService } from 'app/services/pagination.service';

@Component({
    selector: 'app-image',
    templateUrl: './image.component.html',
    styleUrls: ['./image.component.css']
})
export class ImageComponent extends BaseComponent implements OnInit {
    images: Image[];
    image: Image;
    error: any;
    file:any;

    private allItems: any[];

    pager: any = {};

    pagedItems: any[];

    constructor(
        private imageService: ImageService,
        private router: Router,
        private paginationService: PaginationService,
    ) {
        super();
    }

    ngOnInit() {
        this.imageService.getImages().subscribe(images => {
            this.allItems = images.sort((a, b) => {
                if (a.created_at == b.created_at) {
                    return 0;
                }
                return a.created_at > b.created_at ? -1 : 1;
            });
            this.setPage(1);
        });
        this.image = new Image();
    }

    upload() {
        var uploader = document.getElementsByClassName('progress-bar')[0];
        var progress = document.getElementsByClassName('progress')[0];
        var closeBtn = document.getElementsByClassName('close-btn');
        var alert = document.getElementById('hidden');
        var modalTitle = document.getElementsByClassName('modal-title')[0];
        var target = (<HTMLInputElement>document.getElementById('image'));
        var file_name_element = <HTMLDivElement>document.getElementById("file-used");
        var fileLength = target.files.length;

        if (fileLength !== 0) {
            var img = target.files[0].type.match(/\.png|\.jpg|\.jpeg|image\/png|image\/jpg|image\/jpeg/);
        }

        if (fileLength === 0) {
            this.error = 'No file selected';
        } else if (!img) {
            this.error = 'Please upload image file';
        } else {
            this.error = '';
            for (var i = 0; i < target.files.length; i++) {
                var selectedFile = target.files[i];
                var data = {
                    uploader,
                    closeBtn,
                    modalTitle,
                    selectedFile,
                    progress,
                    alert,
                    file_name_element
                }
                this.imageService.imageUpload(data);
            }
            target.value = '';
        }
    }

    onImageClick(image) {
        this.image = image;
        console.log(this.image);
    }

    onDelete(name, key) {
        if (confirm('Are you sure?')) {
            this.imageService.deleteImage(name, key);
            this.router.navigate(['/media/image']);
        }
    }

    filechange(event: Event) {
        var input = <HTMLInputElement>event.target;
        console.log(input.files);
        this.imageService.getImageSize(input.files[0]).then((dims) => {
            console.log(dims);
        });
        var file_name_element = <HTMLDivElement>document.getElementById("file-used");
        var alert = <HTMLDivElement>document.getElementById("hidden");
       // var file = input.files[0];
        var file = []
        for(var i=0; i<input.files.length; i++){
            file.push(input.files[i].name);
        }
        // file_name_element.innerHTML = file.join(', ')
        this.file = input.files
        // console.log( this.file)
        this.error = '';
    }

    setPage(page: number) {
        // get pager object from service
        this.pager = this.paginationService.getPager(this.allItems.length, page);

        // get current page of items
        this.pagedItems = this.allItems.slice(this.pager.startIndex, this.pager.endIndex + 1);
    }


    ngAfterViewInit() {
        super.ngAfterViewInit();
        setTimeout(() => {
            window.dispatchEvent(new Event('data-loaded'));
        }, 500);
    }

}



// WEBPACK FOOTER //
// D:/www/kh_indesso_web/src/app/components/media/image/image.component.ts